import React, { Component, ErrorInfo, ReactNode } from 'react';
import { errorHandler } from '../utils/errorHandler';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        errorHandler.handleError(error, 'Error caught by boundary');
        errorHandler.log('Error info:', errorInfo);
        this.setState({ hasError: true });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h2>Bir hata oluştu</h2>
                    <p>Lütfen sayfayı yenileyip tekrar deneyin.</p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 